import { SPECIAL_DATE_RANGES } from '/src/features/_global/constants';

export const DEFAULT_PRESET_DATE = SPECIAL_DATE_RANGES.LAST_30_DAYS;
export const DEFAULT_LIMIT = 10;
const MICROS_PER_UNIT = 1_000_000;

const integerFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
const decimalFormatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatInteger(value) {
  return integerFormatter.format(Number(value || 0));
}

export function formatDecimal(value) {
  return decimalFormatter.format(Number(value || 0));
}

export function formatCurrencyFromMicros(value) {
  return currencyFormatter.format(Number(value || 0) / MICROS_PER_UNIT);
}

export function formatPlatform(platform) {
  if (!platform) return 'Unknown';
  return platform.charAt(0).toUpperCase() + platform.slice(1).toLowerCase();
}
